/// <amd-module name="Build/Extensions/GitHub/ConnectionList" />
import * as React from "react";

import { ServiceConnectionInfo } from "Build/Extensions/Connection-Services/ServiceConnectionRetrieverService";
import * as Resources from "Build/Extensions/GitHub/Resources";

import * as DesignerResources from "Build/Designer/Resources";
import { IWizardListItem, WizardList } from "Build/Designer/WizardList";

import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

export interface ConnectionListProps {
    showConnections: boolean;
    serviceConnections: ServiceConnectionInfo[];
    getItemPrimaryText: (serviceConnectionInfo: ServiceConnectionInfo) => string;
    getItemSecondaryText: (serviceConnectionInfo: ServiceConnectionInfo) => string;
    onSelectConnection: (connectionId: string) => void;
}

export class ConnectionList extends VssComponent<ConnectionListProps, {}, IVssComponentContext> {
    constructor(props: ConnectionListProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {
        const hasConnections: boolean = (this.props && this.props.serviceConnections && this.props.serviceConnections.length > 0);
        if (!this.props.showConnections || !hasConnections) {
            return <div />;
        }
        // We only want to show the recommended label if there is only one App connection
        const showRecommendedLabel = !this.hasMultipleAppConnections(this.props.serviceConnections);

        const wizardListItems: IWizardListItem[] = this.props.serviceConnections.map(
            s => {
                const labels = [];
                if (showRecommendedLabel && this.isAppConnection(s)) {
                    labels.push(DesignerResources.Recommended.toLocaleLowerCase());
                }
                return {
                    name: this.props.getItemPrimaryText(s),
                    description: this.props.getItemSecondaryText(s),
                    iconUrl: s.imageUrl,
                    iconName: "GitHubLogo",
                    labels: labels
                };
            }
        )

        return (
            <WizardList
                wizardListItems={wizardListItems}
                onClick={(_, data) => {
                    this.props.onSelectConnection(this.props.serviceConnections[data.index].id);
                }}
            />
        );
    }

    private hasMultipleAppConnections = (serviceConnections: ServiceConnectionInfo[]): boolean => {
        return serviceConnections.filter(this.isAppConnection).length > 1;
    };

    private isAppConnection = (serviceConnection: ServiceConnectionInfo): boolean => {
        return serviceConnection && this.props.getItemSecondaryText(serviceConnection) === Resources.GitHubApp;
    }
}
